import $ from 'jquery';

import App from './modules/App';
import { AppInit } from './modules/Init';
import { Validation } from './modules/Validation';
import Bookmarks from './modules/Bookmarks';

App.run(
  () => {
    setTimeout(() => {
      $('.signin .f-control.--validate-input').each(function validateAfterSomeTimeout() {
        if (this.value) {
          Validation.validateInput(this, this.dataset.validate);
        }
      });
    }, 500);

    $('.signin__password-recovery').on('click', () => {
      $('.recovery__form').removeClass('d-none');
      $('.signin__form').addClass('d-none');
    });

    $('.recovery__back-to-login').on('click', () => {
      $('.signin__form').removeClass('d-none');
      $('.recovery__form').addClass('d-none');
    });
    
    $('.signin .show_pass').off('click');
    $('.signin .show_pass').on('click', function () {
      if ($('.signin input[name="password"]').prop('type') === 'password') {
        $('.signin input[name="password"]').prop('type', 'text');
        $(this).html(clientnew_16a_txt);
      } else {
        $('.signin input[name="password"]').prop('type', 'password');
        $(this).html(clientnew_16b_txt);
      }
      return false;
    });

    // eslint-disable-next-line no-new
    new Bookmarks();
  },
  'all',
);

AppInit();
